import { render, staticRenderFns } from "./TransparencyRegulator.vue?vue&type=template&id=b175fd5a&scoped=true&lang=html&"
import script from "./TransparencyRegulator.vue?vue&type=script&lang=js&"
export * from "./TransparencyRegulator.vue?vue&type=script&lang=js&"
import style0 from "./TransparencyRegulator.vue?vue&type=style&index=0&id=b175fd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b175fd5a",
  null
  
)

export default component.exports